<template>
    <div class="nav-box">
        <div class="nav-paths">
            <div class="nav-item">
                <div class="av-logo"><a href="/"><span>AV</span>CHECK</a></div>
            </div>
            <div class="nav-item">
                <a href="how-it-works" class="nav-link">How It Works</a>
            </div>
            <div class="nav-item">
                <a href="pricing" class="nav-link">Pricing</a>
            </div>
            <div class="nav-item">
                <a href="about" class="nav-link">About Us</a>
            </div>
        </div>
        <div v-if="isLogged" class="nav-buttons">
            <div class="main-btn">
                <a href="profile" >Profile</a>
            </div>
            <div class="main-btn red">
                <a @click="logout" >Logout</a>
            </div>
        </div>
        <div v-else class="nav-buttons">
            <div class="main-btn white">
                <a href="login" >Login</a>
            </div>
            <div class="main-btn">
                <a href="signup">Sign Up</a>
            </div>
        </div>
    </div>    
    
</template>

<script>
    export default {
        name: 'DefaultNav',
        computed: {
            isLogged() {
                return this.$store.getters.isLoggedIn
            }
        },
        methods: {
            logout() {
                this.$store.commit('changeId', null)
                this.$store.commit('changeEmail', null)
            },
            updateLoc() {
                this.$store.commit('changeLoc', false)
            }
        },
        mounted() {
            this.updateLoc()
        },


    }
</script>
